import { z } from "zod";

export const participantSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  userId: z.string().optional(), // "other" or specific ID
  pricePointId: z.string().min(1, "Price point is required"),
});

export const registrationSchema = z.object({
  quantity: z.number().min(1).max(10),
  participants: z.array(participantSchema),
});

export type RegistrationFormData = z.infer<typeof registrationSchema>;

/** Rejects price point IDs that are not bookable (e.g. capacity full). */
export function buildRegistrationSchema(bookablePricePointIds: Set<string>) {
  return registrationSchema.superRefine((data, ctx) => {
    data.participants.forEach((p, i) => {
      if (p.pricePointId && !bookablePricePointIds.has(p.pricePointId)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Choose a category that has places available",
          path: ["participants", i, "pricePointId"],
        });
      }
    });
  });
}






